<div class="flex flex-col sbnbDesktop:flex-row" data-element="app-main-wrapper" id="app-container">
  <sbnb-nav *ngIf="authService.isLoggedInSubject | async"></sbnb-nav>
  <div class="flex-1" data-element="app-content-area" id="main-app-area">
    @if (!isDemo) {
      <sbnb-helptext-wrapper [area]="'global'"></sbnb-helptext-wrapper>
    }

    @if (isDemo) {
      <ui-demo-mode-ribbon></ui-demo-mode-ribbon>
    }

    <sbnb-toast-container></sbnb-toast-container>
    <router-outlet></router-outlet>
  </div>

  <sbnb-menu-mobile-tabs
    *ngIf="
      (authService.user$ | async) && (deviceDetectionService.$isMobile | async) === true && !shouldHideMenuBasedOnUrl
    "></sbnb-menu-mobile-tabs>
</div>
